import { render, staticRenderFns } from "./filter-criteria.vue?vue&type=template&id=20d0d820&scoped=true&"
import script from "./filter-criteria.vue?vue&type=script&lang=js&"
export * from "./filter-criteria.vue?vue&type=script&lang=js&"
import style0 from "./filter-criteria.vue?vue&type=style&index=0&id=20d0d820&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20d0d820",
  null
  
)

export default component.exports